module.exports = __webpack_public_path__ + "static/hero-image-b2b039412022b5a704a0a49881d3995e.jpg";